import { render, staticRenderFns } from "./ElementMessage.vue?vue&type=template&id=06ae9c6c&scoped=true"
import script from "./ElementMessage.vue?vue&type=script&lang=js"
export * from "./ElementMessage.vue?vue&type=script&lang=js"
import style0 from "./ElementMessage.vue?vue&type=style&index=0&id=06ae9c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae9c6c",
  null
  
)

export default component.exports